// extracted by mini-css-extract-plugin
export var bold = "EventSummary-module--bold--5cc1f";
export var container = "EventSummary-module--container--0c2f7";
export var content = "EventSummary-module--content--009b6";
export var detailRow = "EventSummary-module--detailRow--fa215";
export var details = "EventSummary-module--details--4e032";
export var detailsGrid = "EventSummary-module--detailsGrid--abcb5";
export var header = "EventSummary-module--header--ab713";
export var label = "EventSummary-module--label--6cb60";
export var title = "EventSummary-module--title--436e8";
export var value = "EventSummary-module--value--ccefa";